import { removeDupes } from '../utils/helpers';

const externalAccounts = (state = {
    items: [],
    fetchInfo: {
        user: {},
        team: {}
    }
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                items: [],
                fetchInfo: {
                    team: {}
                }
            };

        case 'EXTERNAL_ACCOUNTS_FETCH_REQUESTED':
        case 'EXTERNAL_ACCOUNTS_TEAM_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    [action.payload.team ? 'team' : 'user']: {
                        ...state.fetchInfo[action.payload.team ? 'team' : 'user'],
                        loading: true
                    }
                }
            });

        case 'EXTERNAL_ACCOUNTS_FETCH_SUCCEEDED':
        case 'EXTERNAL_ACCOUNTS_TEAM_FETCH_SUCCEEDED':
            if (!action.payload.accounts) {
                return state;
            }

            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.accounts,
                    ...state.items
                ]),
                fetchInfo: {
                    ...state.fetchInfo,
                    [action.payload.team ? 'team' : 'user']: {
                        ...state.fetchInfo[action.payload.team ? 'team' : 'user'],
                        loading: false,
                        fetched: true
                    }
                }
            });

        case 'EXTERNAL_ACCOUNT_CREATE_REQUESTED':
        case 'EXTERNAL_ACCOUNT_ADD_SOCKET':
        case 'EXTERNAL_ACCOUNT_TEAM_CREATE_REQUESTED':
            return Object.assign({}, state, {
                items: removeDupes([...state.items, action.payload.account])
            });

        case 'EXTERNAL_ACCOUNT_CREATE_FAILED':
        case 'EXTERNAL_ACCOUNT_TEAM_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(account => account !== action.payload.fragment)
            });

        case 'EXTERNAL_ACCOUNT_CREATE_SUCCEEDED':
        case 'EXTERNAL_ACCOUNT_TEAM_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(account => account.id !== action.payload.accountId)
                    .map(account => {
                        if (account === action.payload.fragment) {
                            account.id = action.payload.accountId;
                        }

                        return account;
                    })
            });

        case 'EXTERNAL_ACCOUNT_REMOVE_REQUESTED':
        case 'EXTERNAL_ACCOUNT_REMOVE_SOCKET':
        case 'EXTERNAL_ACCOUNT_TEAM_REMOVE_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].filter(account => account.id !== action.payload.accountId)
            });

        default:
            return state;
    }
}

export default externalAccounts;
